import { datadogRum } from '@datadog/browser-rum';
import { getDevice } from '@webtv/devices';
import { PELOTON_PLATFORM, ENVIRONMENT, APP_VERSION_NUMBER } from '@webtv/env';
var WEBTV_APP_ID = '4d312fce-ba90-4bb7-a232-6caf1cc46283';
var WEBTV_TOKEN = 'pub0aa460476ce81d4a282b5834111157b5';
var CHROMECAST_APP_ID = 'bce94a08-6fa5-4756-8c27-cb0f3701978f';
var CHROMCAST_TOKEN = 'pub0b445f9b77e6b5659a3f18edb2383232';

var getAppId = function getAppId(platform) {
  return platform === 'cast-receiver' ? CHROMECAST_APP_ID : WEBTV_APP_ID;
};

var getClientToken = function getClientToken(platform) {
  return platform === 'cast-receiver' ? CHROMCAST_TOKEN : WEBTV_TOKEN;
};

export var captureException = datadogRum.addError;
export var setUser = datadogRum.setUser;
export var setGlobalContext = datadogRum.addRumGlobalContext;
export var addAction = datadogRum.addAction;
export var init = function init() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    sessionReplay: true,
    platform: PELOTON_PLATFORM
  };
  var device = getDevice();
  datadogRum.init({
    applicationId: getAppId(opts.platform),
    clientToken: getClientToken(opts.platform),
    site: 'datadoghq.com',
    service: opts.platform,
    env: ENVIRONMENT,
    version: APP_VERSION_NUMBER,
    sampleRate: 100,
    replaySampleRate: opts.sessionReplay ? 20 : 0,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input'
  });
  datadogRum.startSessionReplayRecording();
  setGlobalContext(GlobalContext.DeviceName, device.friendlyName);
  setGlobalContext(GlobalContext.DeviceOsVersion, device.osVersion);
};
export var GlobalContext;

(function (GlobalContext) {
  GlobalContext["DeviceName"] = "device-name";
  GlobalContext["DeviceOsVersion"] = "device-os-version";
  GlobalContext["EnabledFeatureToggles"] = "enabled-feature-toggles";
})(GlobalContext || (GlobalContext = {}));